// import React, { useState } from "react";
// import { useEffect } from "react";
// import apiConfig from "../../config/apiConfig";
// import {
//   AllCommunityModule,
//   ModuleRegistry,
//   themeAlpine,
//   themeBalham,
// } from "ag-grid-community";
// import { useRaspStore } from "../../store/raspStore";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";
// import { AgGridReact } from "ag-grid-react";
// import { useQuery } from "@tanstack/react-query";
// // ADDED: Import your generated model file dynamically
// import Academic_yearModel from "../../models/Academic_yearModel";
// ModuleRegistry.registerModules([AllCommunityModule]);
// export type ResourceMetaData = {
//   resource: string;
//   fieldValues: any[];
// };

// const getCookie = (name: string): string | null => {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
//   return null;
// };

// const ReadAcademic_year = () => {
//   const [rowData, setRowData] = useState<any[]>([]);
//   const [colDef1, setColDef1] = useState<any[]>([]);
//   const [resMetaData, setResMetaData] = useState<ResourceMetaData[]>([]);
//   const [fields, setFields] = useState<any[]>([]);
//   const [dataToSave, setDataToSave] = useState<any>({});
//   const [requiredFields, setRequiredFields] = useState<string[]>([]);
//   const [fetchData, setFetchedData] = useState<any[]>([]);
//   const [showToast, setShowToast] = useState<any>(false);

//   const regex = /^(g_|archived|extra_data)/;
//   const apiUrl = `${apiConfig.getResourceUrl("academic_year")}?`;
//   const metadataUrl = `${apiConfig.getResourceMetaDataUrl("Academic_year")}?`;
//   const BaseUrl = "${apiConfig.API_BASE_URL}";
//   const getUserAllData = useRaspStore((s:any) => s.getUserAllData);
//   const getUserIdFromJWT = (): any => {
//     try {
//       const token = Cookies.get("access_token"); // adjust cookie name if different
//       if (!token) return null;

//       const decoded: any = jwtDecode(token);
//       // assuming your token payload has "userId" or "sub" field
//       return decoded.userId || decoded.sub || null;
//     } catch {
//       return null;
//     }
//   };
//   // Fetch resource data

//   const {
//     data: dataRes,
//     isLoading: isLoadingDataRes,
//     error: errorDataRes,
//   } = useQuery({
//     queryKey: ["resourceData", "academic_yearRead"],
//     queryFn: async () => {
//       const params = new URLSearchParams();

//       const queryId: any = "GET_ALL";
//       params.append("queryId", queryId);

//       const accessToken = getCookie("access_token");

//       if (!accessToken) {
//         throw new Error("Access token not found");
//       }

//       const response = await fetch(
//         `${apiConfig.getResourceUrl("academic_year")}?` + params.toString(),
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`, // Add token here
//           },
//           credentials: "include", // include cookies if needed
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Error: " + response.status);
//       }

//       const data = await response.json();

//       return data.resource;
//     },
//   });

//   // --- Transform API data into model objects and then JSON ---
//   useEffect(() => {
//     if (dataRes) {
//       let dataToStore = { resource: "academic_year", records: dataRes };
//       useRaspStore.getState().initializeStore(getUserIdFromJWT(), dataToStore);
//       //ADDED: Convert array of plain objects → array of model instances
//       const modelObjects = dataRes.map((obj: any) =>
//         Academic_yearModel.fromJson(obj)
//       );

//       // ADDED: Convert array of model instances → array of JSON objects (for ag-grid)
//       const jsonObjects = modelObjects.map((model: any) => model.toJson());

//       // ADDED: Set final array for AgGrid
//       setRowData(jsonObjects);
//     }
//   }, [dataRes]);

//   const {
//     data: dataResMeta,
//     isLoading: isLoadingDataResMeta,
//     error: errorDataResMeta,
//   } = useQuery({
//     queryKey: ["resourceMetaData", "academic_yearRead"],
//     queryFn: async () => {
//       const response = await fetch(
//         `${apiConfig.getResourceMetaDataUrl("academic_year")}?`,
//         {
//           method: "GET",
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Error: " + response.status);
//       }

//       const data = await response.json();
//       setResMetaData(data);
//       setFields(data[0]?.fieldValues || []);
//       const required = data[0]?.fieldValues
//         .filter((field: any) => !regex.test(field.name))
//         .map((field: any) => field.name);
//       setRequiredFields(required || []);
//       return data;
//     },
//   });

//   useEffect(() => {
//     const fields = requiredFields.filter((field: any) => field !== "id") || [];

//     const columns = fields.map((field: any) => ({
//       field: field,
//       headerName: field,
//       editable: false,
//       resizable: true,
//       sortable: true,
//       filter: true,
//     }));

//     setColDef1(columns);
//   }, [requiredFields]);

//   const defaultColDef = {
//     flex: 1,
//     minWidth: 100,
//     editable: false,
//   };

//   return (
//     <div>
//       <div>
//         {rowData.length === 0 && colDef1.length === 0 ? (
//           <div>No data available. Please add a resource attribute.</div>
//         ) : (
//           <div
//             className="ag-theme-alpine"
//             style={{ height: 500, width: "100%" }}
//           >
//             <AgGridReact
//               rowData={rowData}
//               columnDefs={colDef1}
//               defaultColDef={defaultColDef}
//               pagination={true}
//               paginationPageSize={10}
//               animateRows={true}
//               rowSelection="multiple"
//             />
//           </div>
//         )}
//       </div>
//       {showToast && (
//         <div
//           className="toast-container position-fixed top-20 start-50 translate-middle p-3"
//           style={{ zIndex: 1550 }}
//         >
//           <div
//             className="toast show"
//             role="alert"
//             aria-live="assertive"
//             aria-atomic="true"
//           >
//             <div className="toast-header">
//               <strong className="me-auto">Success</strong>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="toast"
//                 aria-label="Close"
//                 onClick={() => setShowToast(false)}
//               ></button>
//             </div>
//             <div className="toast-body text-success text-center">
//               Created successfully!
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReadAcademic_year;


import React, { useState, useEffect } from "react";
import apiConfig from "../../config/apiConfig";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useRaspStore } from "../../store/raspStore";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Academic_yearModel from "../../models/Academic_yearModel";

ModuleRegistry.registerModules([AllCommunityModule]);

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

const ReadAcademic_year = () => {
  const queryClient = useQueryClient();
  const [rowData, setRowData] = useState<any[]>([]);
  const [colDef1, setColDef1] = useState<any[]>([]);
  const [requiredFields, setRequiredFields] = useState<string[]>([]);

  const regex = /^(g_|archived|extra_data)/;
  const getUserAllData = useRaspStore((s: any) => s.getUserAllData);

  const getUserIdFromJWT = () => {
    try {
      const token = Cookies.get("access_token");
      if (!token) return null;
      const decoded: any = jwtDecode(token);
      return decoded.userId || decoded.sub || null;
    } catch {
      return null;
    }
  };

  /* ================= RESOURCE DATA ================= */
  const { data: dataRes, isLoading: dataLoading } = useQuery({
    queryKey: ["resourceData", "academic_yearRead"],
    queryFn: async () => {
      const token = getCookie("access_token");
      if (!token) throw new Error("Token missing");

      const res = await fetch(
        `${apiConfig.getResourceUrl("academic_year")}?queryId=GET_ALL`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const json = await res.json();
      return json.resource;
    },
  });

  useEffect(() => {
    if (!dataRes) return;

    useRaspStore.getState().initializeStore(getUserIdFromJWT(), {
      resource: "academic_year",
      records: dataRes,
    });

    const models = dataRes.map((obj: any) =>
      Academic_yearModel.fromJson(obj)
    );

    setRowData(models.map((m: any) => m.toJson()));

  }, [dataRes]);

  /* ================= METADATA ================= */
  const { isLoading: metaLoading } = useQuery({
    queryKey: ["resourceMetaData", "academic_yearRead"],
    queryFn: async () => {
      const res = await fetch(
        apiConfig.getResourceMetaDataUrl("AcademicYear") // ✅ FIXED CASE
      );

      const data = await res.json();

      const fields =
        data?.[0]?.fieldValues
          ?.filter((f: any) => !regex.test(f.name))
          .map((f: any) => f.name) || [];

      setRequiredFields(fields);
      return data;
    },
  });

  /* ================= DELETE HANDLER ================= */
  const handleDelete = async (id: string) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    const payload = { id };
    const formData = new FormData();
    const base64 = btoa(JSON.stringify(payload));

    formData.append("resource", base64);
    formData.append("action", "DELETE");

    try {
      const token = getCookie("access_token");
      const response = await fetch(`${apiConfig.getResourceUrl("academic_year")}?`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!response.ok) throw new Error("Delete failed");

      await queryClient.invalidateQueries({
        queryKey: ["resourceData", "academic_yearRead"],
      });
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete record. Please try again.");
    }
  };

  /* ================= HEADER FORMATTER ================= */
  const prettifyHeader = (str: string) =>
    (str || "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());

  // ✅ Date Formatter helper
  const formatDateStr = (value: any) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    // formats to DD MMM YYYY (eg 01 Apr 2024)
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  /* ================= GRID COLUMNS ================= */
  useEffect(() => {
    if (!requiredFields.length) return;

    const columns: any[] = requiredFields
      .filter((f) => f !== "id")
      .map((field) => ({
        field,
        headerName: prettifyHeader(field),
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter: (params: any) => {
          if (field.toLowerCase().includes("date") || field.toLowerCase().includes("time") || field.toLowerCase() === "dob") {
            return formatDateStr(params.value);
          }
          return params.value;
        }
      }));

    columns.push({
      headerName: "Action",
      field: "action",
      width: 150,
      cellRenderer: (params: any) => (
        <button
          className="btn btn-danger"
          style={{
            fontSize: "14px",
            padding: "6px 14px",
            borderRadius: "8px",
            fontWeight: 600,
          }}
          onClick={() => handleDelete(params.data.id)}
        >
          Delete
        </button>
      ),
    });

    setColDef1(columns);
  }, [requiredFields]);

  const defaultColDef = {
    flex: 1,
    minWidth: 120,
  };

  /* ================= RENDER ================= */
  if (dataLoading || metaLoading) {
    return <div>Loading Academic Year...</div>;
  }

  return (
    <div style={{ height: 500 }}>
      <div className="ag-theme-alpine" style={{ height: "100%" }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={colDef1}
          defaultColDef={defaultColDef}
          pagination
          paginationPageSize={10}
        />
      </div>
    </div>
  );
};

export default ReadAcademic_year;
